import useLang from "../../../hooks/useLang";
import { useLocation } from "react-router-dom";

// ${location?.pathname}

const useAnalysesBlock = (assessment) => {
  const lang = useLang();
  const location = useLocation();

  const analyses = Array.isArray(assessment?.data?.analyses)
    ? assessment?.data?.analyses?.map((item) => ({
        ...item,
        state: lang(`analyses.${item.state}`),
      }))
    : [];

  const analysesArtice =
    analyses.length > 0
      ? {
          header: {
            title: lang("analyses.title"),
          },
          items: {
            id: "analysesTable",
            type: "table",
            data: analyses,
            config: [
              {
                id: "date_created",
                link: (data) => `${location?.pathname}/analyses/${data?.id}`,
                width: 56,
              },
              {
                id: "date_modified",
                width: 56,
              },
              {
                id: "state",
                width: 56,
              },
            ],
          },
        }
      : null;

  return analysesArtice;
};

export default useAnalysesBlock;
